"use strict";

angular
	.module('rmToolbar')
	.config(['$provide', function ($provide) {

	  	$provide.decorator('mdMenuDirective', ['$delegate', function ($delegate) {

	  		//Patch for custom class
	  		var link = function ( scope, element, attrs, ctrls ) {

				var mdMenuCtrl = ctrls[0];
				var isInMenuBar = ctrls[1] != undefined;
				var customContainer = '';

				if( element[0].attributes.getNamedItem("md-container-class") ) {
					customContainer += ' ' + element[0].attributes.getNamedItem("md-container-class").value;
				}

				// Move everything into a md-menu-container and pass it to the controller
				var menuContainer = angular.element(
					'<div class="md-open-menu-container md-whiteframe-z2'+customContainer+'"></div>'
				);
			
				var menuContents = element.children()[1];
					menuContainer.append(menuContents);
				
				if (isInMenuBar) {
					element.append(menuContainer);
					menuContainer[0].style.display = 'none';
				}

				mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar });

				scope.$on('$destroy', function() {
				mdMenuCtrl
					.destroy()
					.finally(function(){
						menuContainer.remove();
					});
				});
	    	}

	  		$delegate[0].compile = function() {
			      
				return function(scope, element, attrs, ctrls) {
				
					link.apply(this, arguments);
				};
			};

	    	return $delegate;
	  	 } ] );
	}]);

